import React from "react";
import styled from "styled-components";
import { Icon } from "../../atoms";
import { CryptoHeaderMenu } from "../CryptoHeaderMenu/CryptoHeaderMenu";
import { Link } from "react-router-dom";
import { CoinListService } from "../../../utils/RxServices/SharedService";
import { useLocation } from "react-router-dom";

const WrapperDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 52px;
`;
const ActionDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const TradeHeader: React.FC = () => {
  const location = useLocation();
  const broadCastOpenList = () => {
    CoinListService.openList(true);
  };
  return (
    <WrapperDiv className="container">
      <CryptoHeaderMenu onClick={broadCastOpenList} />
      <ActionDiv>
        <Link to="/crypto/trade/history" style={{ margin: "0 8px" }}>
          <Icon name="orders" width="32px" height="32px"></Icon>
        </Link>
        {location.pathname === "/crypto/trade/buy" && (
          <div
            style={{ margin: "0 8px" }}
            onClick={() => window.history.back()}
          >
            <Icon name="chartOff" width="22px" height="22px"></Icon>
          </div>
        )}
        <Link to="/news" style={{ margin: "0 8px" }}>
          <Icon name="news" width="32px" height="32px"></Icon>
        </Link>
        <Link to="/notification" style={{ margin: "0 8px" }}>
          <Icon name="notificationOff" width="32px" height="32px"></Icon>
        </Link>
      </ActionDiv>
    </WrapperDiv>
  );
};
